import { useState } from "react";
import styled from "styled-components";
import StartGame from "./Components/StartGame";
import GamePlay from "./Components/GamePlay";

function App() {
  const [isGameStarted,setIsGameStarted]=useState(true);
  const StartGamePlay=()=>{
    setIsGameStarted(!isGameStarted);
  }
  return (
    <div className="App">
      <Container>
        {isGameStarted ? <StartGame Toggle={StartGamePlay}/> : <GamePlay/> }
      </Container>
    </div>
  );
}
export default App;
 const Container=styled.div`
    max-width:1180px;
    margin:0 auto;
 `;